/**
 * Frontend mirror of apps/worker/src/lib/season.ts. Keep these two in sync
 * — if the WBGT publication window changes, update both files. The logic
 * is duplicated rather than imported because the worker compiles for
 * workerd and the web bundle has different module conventions; the file
 * is small enough that the duplication is cheap.
 */

const JST_OFFSET_MS = 9 * 60 * 60 * 1000;

export const SERVICE_START_MMDD = '0422';
export const SERVICE_END_MMDD = '1021';

type JstParts = { year: number; month: number; day: number };

function toJstParts(date: Date): JstParts {
  const jst = new Date(date.getTime() + JST_OFFSET_MS);
  return {
    year: jst.getUTCFullYear(),
    month: jst.getUTCMonth() + 1,
    day: jst.getUTCDate(),
  };
}

export function isInService(now: Date = new Date()): boolean {
  const { month, day } = toJstParts(now);
  const todayMmdd = month * 100 + day;
  return todayMmdd >= parseInt(SERVICE_START_MMDD, 10)
    && todayMmdd <= parseInt(SERVICE_END_MMDD, 10);
}

export function nextResumeDate(now: Date = new Date()): string {
  const { year, month, day } = toJstParts(now);
  const todayMmdd = month * 100 + day;
  const startMmdd = parseInt(SERVICE_START_MMDD, 10);
  const startYear = todayMmdd <= startMmdd ? year : year + 1;
  const startMonth = Math.floor(startMmdd / 100);
  const startDay = startMmdd % 100;
  return `${startYear}-${String(startMonth).padStart(2, '0')}-${String(startDay).padStart(2, '0')}`;
}
